module.exports = __webpack_public_path__ + "img/spark_basket_02.71b5c356.png";